import axios from "../service/axios";
import { toast } from "react-toastify";
import { round } from "lodash";
import { transformElement } from "../utils/helpers";
import { pixelsToUnits } from "../utils/helpers";

import { getLoggedInUser } from "../utils/authUtils";

export const fetchWarehouseLayout = async (objectType, layoutId) => {
  const layout_Id = parseInt(layoutId);
  try {
    const { data } = await axios.get(`layout-objects/${layout_Id}`);
    const response = data?.data;
    const responseData = { objectType, response };
    return { responseData };
  } catch (error) {
    // const {
    //   response: {
    //     data: { message },
    //   },
    // } = error;
    // toast.error(message);
    console.log("error", error);
  }
};

export const getLayoutObjects = async (layoutId,signal) =>{
  const layout_Id = parseInt(layoutId);
  try{
    const { data:{data:response} } = await axios.get(`layout-objects/${layout_Id}`,{signal});
    return response || [];
  }catch(error){
    toast.error("Issue while fetching layout objects");
    console.log('fetchLayoutObject Error =>', error);
  }
}

export const onSaveLayoutObject = async (warehouseLayoutId, layoutObject, successMsg = "Saved Successfully") => {
  const {
    name,
    code,
    width,
    color,
    type,
    facingDirection,
    x,
    y,
    x1,
    y1,
    x2,
    y2,
    objectType,
    height,
    id,
    hasElementChanges,
    zIndex,
    unitType,
    length,
    rotation,
  } = layoutObject;

  let payload = {};

  const rackWidth = x2 - x1;
  const rackHeight = y2 - y1;

  if (objectType === "rack") {
    const transformedBins = layoutObject.bins?.map((bin, index) => {
        // const width = round(pixelsToUnits(Math.abs(bin.x2 - bin.x1), unitType), 2);
        // const height = round(pixelsToUnits(Math.abs(bin.y2 - bin.y1), unitType), 2);
        return {
          ...bin,
          id: isNaN(+bin.id) ? null : bin.id,
          name: bin.name,
          code: bin.code,
          labels:bin.labels,
          width: bin.width,
          height: bin.height,
          depth: bin.depth || 0,
          // positionX: round(pixelsToUnits(bin.x1, unitType), 2),
          // positionY: round(pixelsToUnits(bin.y1, unitType), 2),
        };
      });
      
     const len = rackWidth > rackHeight ? length : width;
     const wid = rackWidth > rackHeight ? width : length;
    
    payload = {
        id: isNaN(+id) ? null : id,
        name: name,
        code: code,
        warehouseLayoutId: warehouseLayoutId,
        positionX: layoutObject.positionX,
        positionY: layoutObject.positionY,
        length: len,
        width: wid,
        orientation: rotation || 0,
        facingDirection: 'N',
        color,
        hasElementChanges,
        zIndex,
        objectType,
        bins: transformedBins,
        // columns,
        unitType,
      };
    
  } else if (objectType === "wall" || objectType === "area" || objectType === "dock") {
    payload = {
      code: layoutObject.code,
      color,
      id: isNaN(+id) ? null : id,
      length: length,
      width: width,
      name: name,
      positionX:  layoutObject.positionX,
      positionY:  layoutObject.positionY,
      warehouseLayoutId: warehouseLayoutId,
      zIndex,
      objectType,
      unitType: unitType,
      orientation: rotation || 0,
      ...(objectType === "area" && { subAreas:[] })
    };

    //haveSubAreas
    if(objectType === "area" && layoutObject.subAreas?.length){
      const subAreas = layoutObject.subAreas?.map((subArea) => {
        return {
               areaId: layoutObject.id,
               id: subArea?.id,
               name: subArea?.name,
               code: subArea?.code,
               x: subArea?.positionX, unitType,
               y: subArea?.positionY, unitType,
               width: subArea?.width,
               height: subArea?.height,
               unitType: unitType,
             };
      }) || [];
      payload.subAreas = subAreas;
    }
  }

  if (layoutObject?.id && !layoutObject?.id.toString().startsWith("temp_")) {
    payload.id = layoutObject?.id;
  }

  try {
    const { data: { data } } = await axios.post("layout-objects", payload);
    let message = `Rack ${payload.id ? "updated" : "created"} successfully`;
    message = successMsg === "Saved Successfully" ? (message = `Rack ${payload.id ? "updated" : "created"} successfully`) : (message = successMsg);
    toast.success(message, { autoClose: 2000 });

    const transformedElement = transformElement(data);
    
    return transformedElement;
  } catch (error) {
    //  const {
    //    response: {
    //      data: { message },
    //    },
    //  } = error;
    //  const defaultErrorMessage = "Oops Something went wrong";
    //  toast.error(message || defaultErrorMessage);
    console.log("error", error);
    throw error;
  }
};

export const onRemoveElement = async (id) => {
  try {
    const { data } = await axios.delete(`layout-objects/${id}`);
    toast.success("rack deleted successfully", { autoClose: 1000 });
    // dispatch({ type: "REMOVE_ELEMENT", payload: deleteElement });
    // setDeleteElement({});
  } catch (error) {
    const {
      response: {
        data: { message },
      },
    } = error;
    const defaultErrorMessage = "Oops Something went wrong";
    toast.error(message || defaultErrorMessage, { autoClose: 2000 });
    console.log("error", error);
  }
};


export const updateLayoutObject = async (payload)=>{
  try{
    const {data} = await axios.put(`layout-objects/update-layout-object`,payload);
    return data;
  }catch(err){
    console.log(err);
    throw err;
  }
}





//Get SubBins
export const getSubBins = async (layoutId,binId) => {
  try {
    const { data } = await axios.get(`layout-objects/${layoutId}/bins/${binId}/sub-bins`);
    return data;
  } catch (error) {
    const {
      response: {
        data: { message },
      },
    } = error;
    const defaultErrorMessage = "Oops Something went wrong";
    toast.error(message || defaultErrorMessage, { autoClose: 2000 });
    console.log("error", error);
  }
}


//Save SubBins
export const saveSubBins = async (layoutId,binId,payload) => {
  try {
    const { data } = await axios.post(`layout-objects/${layoutId}/bins/${binId}/sub-bins`,payload);
    toast.success(data?.message, { autoClose: 1000 });
    return data;
  } catch (error) {
    const {
      response: {
        data: { message },
      },
    } = error;
    const defaultErrorMessage = "Oops Something went wrong";
    toast.error(message || defaultErrorMessage, { autoClose: 2000 });
    console.log("error", error);
  }
  
}

//Delete SubBins
export const deleteSubBins = async (layoutId,binId,subBinId) => {
  try {
    const { data } = await axios.delete(`layout-objects/${layoutId}/bins/${binId}/sub-bins/${subBinId}`);
    toast.success(data?.message, { autoClose: 1000 });
    return data;
  } catch (error) {
    const {
      response: {
        data: { message },
      },
    } = error;
    const defaultErrorMessage = "Oops Something went wrong";
    toast.error(message || defaultErrorMessage, { autoClose: 2000 });
    console.log("error", error);
  }
  
}